// #499: Zimmer als Untereinheiten einer Wohnung (objekt_einheiten.uebergeordnete_einheit_id).
// Ein Zimmer ist eine normale Einheit mit eigenem Mieter, Vertrag, Miete und Kaution.
// In Übersichten (Belegung, Fläche, Anzahl Einheiten) zählt die Wohnung; ihre Zimmer werden ihr zugerechnet.

export interface MitWohnung { id: string; uebergeordnete_einheit_id?: string | null }

/** Zimmer-ID → Wohnungs-ID, nur für Zimmer, deren Wohnung in der Liste ist. */
export function wohnungJeZimmer(einheiten: readonly MitWohnung[]): Map<string, string> {
  const ids = new Set(einheiten.map(e => e.id));
  const karte = new Map<string, string>();
  for (const e of einheiten) {
    const w = e.uebergeordnete_einheit_id;
    if (w && w !== e.id && ids.has(w)) karte.set(e.id, w);
  }
  return karte;
}

/** Einheiten ohne die Zimmer, die einer Wohnung in der Liste zugerechnet werden. */
export function ohneZimmer<T extends MitWohnung>(einheiten: readonly T[]): T[] {
  const karte = wohnungJeZimmer(einheiten);
  return einheiten.filter(e => !karte.has(e.id));
}

/** Einheit, der ein Mieter in Übersichten zugerechnet wird (Zimmer → Wohnung). */
export function zugerechneteEinheit(einheitId: string | null | undefined, karte: ReadonlyMap<string, string>): string | null {
  if (!einheitId) return null;
  return karte.get(einheitId) ?? einheitId;
}

/** Vorschlag für die Bezeichnung des nächsten Zimmers: „W3 · Zimmer 2“ (erste freie Nummer). */
export function zimmerBezeichnung(wohnung: string, bestehende: readonly (string | null)[]): string {
  const belegt = new Set(bestehende.map(b => (b ?? '').trim().toLowerCase()));
  const basis = wohnung.trim() || 'Wohnung';
  for (let n = 1; ; n++) {
    const vorschlag = `${basis} · Zimmer ${n}`;
    if (!belegt.has(vorschlag.toLowerCase())) return vorschlag;
  }
}

/** Fehlertext beim Löschen: Wohnung mit Zimmern (FK on delete restrict) verständlich melden. */
export function loeschFehlerText(meldung: string): string {
  return meldung.includes('uebergeordnete_einheit_id')
    ? 'Diese Wohnung hat noch Zimmer. Bitte zuerst die Zimmer löschen.'
    : meldung;
}
